/**
 * CategorieEditor — estratto in file autonomo nello Sprint 4D.2
 * per evitare dipendenza circolare tra AnagraficaDatiForm.jsx
 * e pages/Anagrafiche.jsx.
 */
import React from "react";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import {
  CATEGORIE_KEYS, CATEGORIE_LABELS, SUB_LABELS,
} from "@/lib/anagrafiche";

export default function CategorieEditor({ taxonomy, value, onChange }) {
  const toggle = (key, sub) => {
    const cur = value[key] || [];
    const next = cur.includes(sub) ? cur.filter((x) => x !== sub) : [...cur, sub];
    onChange({ ...value, [key]: next });
  };
  return (
    <div className="border-t pt-3">
      <Label className="text-xs uppercase tracking-wider text-slate-500">Categorie *</Label>
      <p className="text-[11px] text-slate-400 mb-2">Almeno 1 sub-categoria deve essere selezionata.</p>
      <div className="space-y-3">
        {CATEGORIE_KEYS.map((key) => {
          const subs = taxonomy[key] || [];
          if (subs.length === 0) return null;
          return (
            <div key={key} className="border border-slate-200 rounded-lg p-2 bg-slate-50/40">
              <div className="text-xs font-semibold mb-1.5 text-slate-700">{CATEGORIE_LABELS[key]}</div>
              <div className="flex flex-wrap gap-2">
                {subs.map((sub) => (
                  <label key={sub} className="flex items-center gap-1.5 text-xs px-2 py-1 rounded bg-white border border-slate-200 cursor-pointer hover:border-blue-300">
                    <Checkbox checked={(value[key] || []).includes(sub)}
                              onCheckedChange={() => toggle(key, sub)}
                              data-testid={`anag-cat-${key}-${sub}`} />
                    {SUB_LABELS[sub] || sub}
                  </label>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
